$(document).ready(function () {
    var lang = $('html').attr('lang');
    $.datepicker.setDefaults($.datepicker.regional[lang]);
    var datepicker_options = {
        defaultDate: new Date(), // Установка сегодняшней даты
        closeText: "Закрити",
        prevText: "Попередній",
        nextText: "найближчий",
        currentText: "Сьогодні",
        monthNames: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень",
            "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
        monthNamesShort: ["Січ", "Лют", "Бер", "Кві", "Тра", "Чер",
            "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
        dayNames: ["неділя", "понеділок", "вівторок", "середа", "четвер", "п’ятниця", "субота"],
        dayNamesShort: ["нед", "пнд", "вів", "срд", "чтв", "птн", "сбт"],
        dayNamesMin: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        weekHeader: "Тиж",
        dateFormat: "dd.mm.yy",
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: ""
    }
    if (lang == 'ru') {
        datepicker_options = {
            defaultDate: new Date(), // Установка сегодняшней даты
            closeText: "Закрыть",
            prevText: "Пред",
            nextText: "След",
            currentText: "Сегодня",
            monthNames: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь",
                "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"],
            monthNamesShort: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн",
                "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
            dayNames: ["воскресенье", "понедельник", "вторник", "среда", "четверг", "пятница", "суббота"],
            dayNamesShort: ["вск", "пнд", "втр", "срд", "чтв", "птн", "сбт"],
            dayNamesMin: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
            weekHeader: "Нед",
            dateFormat: "dd.mm.yy",
            firstDay: 1,
            isRTL: false,
            showMonthAfterYear: false,
            yearSuffix: ""
        }
    }
    if (lang == 'en') {
        datepicker_options = {
            defaultDate: new Date(), // Установка сегодняшней даты
            dateFormat: "dd.mm.yy"
        }
    }
    if ($('#delivery-date').length) {
        $('#delivery-date').datepicker(datepicker_options);
        // Открытие календаря при клике на иконку
        $('.datepicker-icon').on('click', function () {
            $('#delivery-date').datepicker('show');
        });
    }

    $(document).on('change', '.cart-date', function (event) {
        var checkboxDate = $(this);
        checkboxDate.toggleClass('change-date');
        // if (!checkboxDate.hasClass('change-date') || !checkboxDate.is(':checked')) {
        //     checkboxDate.prop("checked", false);
        //     checkboxDate.attr("checked", '');
        //     $('.change-date__value').html('');
        //     // $('.checkbox-block--date').addClass('hidden');
        //     $('#delivery-date').val('');
        //     $('.delivery-date__submit').click();
        // }
    });
    var custom_active_facets = $('.custom-active-facets');
    if (custom_active_facets) {
        var active_facets_desktop = $('.active-facets-desktop');
        if (active_facets_desktop) {
            custom_active_facets.html(active_facets_desktop.clone(true));
        }
    }

    scrollIntervalID = setInterval(stickIt, 100);
    var topHeight = 0;
    function stickIt() {
        var product_info_cart = $('.main-product-quick-view-form');
        if (product_info_cart.length) {
            if (topHeight < product_info_cart.outerHeight()) {
                topHeight = product_info_cart.outerHeight();
            }
            var boxInitial = $('.product-info');
            var boxInitialTop = boxInitial.offset().top - 50;
            // console.log(topHeight);
            if ($(window).width() < 989 && $(window).scrollTop() >= boxInitialTop) {
                boxInitial.css('margin-top', topHeight + 'px')
                product_info_cart.addClass('sticky');
            } else {
                boxInitial.css('margin-top', '0px')
                product_info_cart.removeClass('sticky');
            }
        }
    }
});

// Collectionpage: sort_by
// var collectionSortAsync = function () {
//     var sort_by = document.getElementById('SortBy');
//     if (sort_by != null) {
//         sort_by.addEventListener('change', function () {
//             setTimeout(function () {
//                 const form = document.querySelector('#FacetSortForm');
//                 if (form) {
//                     form.submit();
//                 }
//             }, 1);
//         });
//     }
// };
// collectionSortAsync();

document.addEventListener('DOMContentLoaded', () => {
    const slickPrevArrow = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.0875 13.825L9.27084 10L13.0875 6.175L11.9125 5L6.91251 10L11.9125 15L13.0875 13.825Z" fill="#111827"/></svg>';
    // const slickPrevArrow = '<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M3 11.0004C3 10.6591 3.13999 10.3177 3.41856 10.0577L10.5612 3.39106C11.1197 2.86973 12.0225 2.86973 12.5811 3.39106C13.1396 3.91239 13.1396 4.75506 12.5811 5.27639L6.44845 11.0004L12.5811 16.7244C13.1396 17.2457 13.1396 18.0884 12.5811 18.6097C12.0225 19.1311 11.1197 19.1311 10.5612 18.6097L3.41856 11.9431C3.13999 11.6831 3 11.3417 3 11.0004Z" fill="#1E1F1F" fill-opacity="1"/></svg>';
    const slickNextArrow = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.91248 13.825L10.7291 10L6.91248 6.175L8.08748 5L13.0875 10L8.08748 15L6.91248 13.825Z" fill="#111827"/></svg>';
    // const slickNextArrow = '<svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M13 11.0003C13 11.3417 12.86 11.683 12.5814 11.943L5.43884 18.6097C4.88029 19.131 3.97747 19.131 3.41891 18.6097C2.86036 18.0883 2.86036 17.2457 3.41891 16.7243L9.55155 11.0003L3.41891 5.27634C2.86036 4.75501 2.86036 3.91234 3.41891 3.39101C3.97747 2.86967 4.88029 2.86967 5.43884 3.39101L12.5814 10.0577C12.86 10.3177 13 10.659 13 11.0003Z" fill="#1E1F1F"/> </svg>';
    function initAdditionalProducts(refresh = false) {
        if (false) {
            // Slick slider for related products in cart
            let slidesToShow = 3;
            if (document.querySelector('.cart__contents')) {
                slidesToShow = 4;
            }
            let additionalProducts = document.querySelectorAll('.additional-products-cart--items--wrap');
            if (additionalProducts) {
                additionalProducts.forEach((item) => {
                    if (!item.className.includes('slick-initialized')) {
                        console.log('init slick');
                        $(item).slick({
                            infinite: true,
                            slidesToShow: slidesToShow,
                            slidesToScroll: 1,
                            dots: false,
                            centerMode: false,
                            prevArrow: '<button type="button" class="slick-prev slick-arrow">' + slickPrevArrow + '</button>',
                            nextArrow: '<button type="button" class="slick-next slick-arrow">' + slickNextArrow + '</button>',
                            responsive: [
                                {
                                    breakpoint: 769,
                                    settings: {
                                        slidesToShow: 2,
                                        centerPadding: '10px'
                                    }
                                }
                            ]
                        });
                        $(item).slick('setPosition');
                    } else {
                        console.log('refresh');
                        // $(item).slick('reInit');
                        // $(item).slick('refresh');
                        // Manually refresh positioning of slick
                        $(item).slick('setPosition');
                    }
                });
            }
        }
    }
    if (document.querySelector('.cart__contents')) {
        initAdditionalProducts();
    }
    let miniCartWrap = document.getElementById('mini-cart__wrap');
    if (miniCartWrap) {
        miniCartWrap.addEventListener('change', initAdditionalProducts());
    }
    let emptyCartWrap = document.querySelector('empty-cart-wrap');
    if (emptyCartWrap) {
        emptyCartWrap.addEventListener('change', initAdditionalProducts());
    }
    let headerIconCart = document.querySelector('.header__icon--cart');
    if (headerIconCart) {
        headerIconCart.addEventListener('click', () => {
            initAdditionalProducts();
        });
    }
    let productsListAtc = document.querySelectorAll('.products-list__product-atc');
    if (productsListAtc) {
        productsListAtc.forEach((atc) => {
            atc.addEventListener('click', () => {
                initAdditionalProducts();
            });
        });
    }
    let miniCartTabs = document.querySelectorAll('.mini-cart-bottom .product-info__tabs--details');
    if (miniCartTabs) {
        miniCartTabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                initAdditionalProducts();
            });
        });
    }
    $(function () {
        let dtToday = new Date();

        let month = dtToday.getMonth() + 1;
        let day = dtToday.getDate();
        let year = dtToday.getFullYear();
        if (month < 10)
            month = '0' + month.toString();
        if (day < 10)
            day = '0' + day.toString();
        let maxDate = year + '-' + month + '-' + day;
        $('#delivery-date').attr('min', maxDate);
    });

    const datePicker = document.getElementById('delivery-date');

    const preselectedDate = document.querySelector('.cart-date');
    if (preselectedDate) {
        datePicker.value = preselectedDate.getAttribute('preselectedDate');
    }

    const book_series__show_more = document.querySelector('.book_series__show_more');
    const book_series__show_less = document.querySelector('.book_series__show_less');
    const book_series = document.querySelectorAll('.book_series .grid__item');
    if (book_series__show_more && book_series__show_less) {
        book_series__show_more.addEventListener('click', () => {
            book_series__show_more.classList.remove('active');
            book_series__show_less.classList.add('active');
            book_series.forEach((item, index) => {
                item.classList.remove('hidden');
            })
        })
        book_series__show_less.addEventListener('click', () => {
            book_series__show_more.classList.add('active');
            book_series__show_less.classList.remove('active');
            book_series.forEach((item, index) => {
                item.classList.remove('hidden');
                if (index > 3) {
                    item.classList.add('hidden');
                }
            })
            document.querySelector('.book_series').scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
        })
    }
    const mini_cart_open = document.querySelectorAll('.mini_cart_open');
    if (mini_cart_open) {
        mini_cart_open.forEach((btn) => {
            btn.addEventListener('click', () => {
                const cartDrawerCustomMiniCartOpen = document.getElementById('mini-cart__wrap');
                const closeQuickViewMiniCartOpen = document.getElementById('close-quick-view');
                if (closeQuickViewMiniCartOpen) {
                    closeQuickViewMiniCartOpen.addEventListener('click', function () {
                        cartDrawerCustomMiniCartOpen.classList.add('open');
                    });
                }
                if (closeQuickViewMiniCartOpen) {
                    closeQuickViewMiniCartOpen.addEventListener('click', function () {
                        cartDrawerCustomMiniCartOpen.classList.add('open');
                    });
                }
            })
        })
    }
    const date_wrap = document.querySelector('.checkbox-block--date');
    const date_wrap_val = document.querySelector('.change-date__value');
    const updateDateButton = document.querySelector('.delivery-date__submit');
    const additionalProductsCart = document.querySelector('.additional-products-cart');
    const checkboxDate = document.querySelector('.cart-date');
    const checkboxZakladynka = document.querySelector('.zakladynka');
    const products = document.querySelector('.additional-products-cart--block');
    const checkboxBlock = document.querySelector('.checkbox-block');

    const allBlocks = document.querySelectorAll('.hidden-block-cart');
    if (allBlocks) {
        setTimeout(() => {
            allBlocks.forEach((item) => {
                item.classList.add('hidden');
            });
        }, 1000)
    }

    function checkboxZakladynka_change() {
        allBlocks.forEach((i) => {
            i.classList.add('hidden')
        });
        if (checkboxZakladynka.checked) {
            products.classList.remove('hidden');

            checkboxDate.checked = false;
            checkboxBlock.classList.add('hidden');
            date_wrap_val.innerHTML = " ";
            checkboxDate.classList.remove('change-date');
            datePicker.value = '';
            checkboxDate.setAttribute('preselectedDate', '');
            checkboxDate.removeAttribute('checked');
            checkboxDate.addEventListener('change', checkboxDate_change);

            additionalProductsCart.classList.remove('visibility-hidden--custom');
            additionalProductsCart.classList.remove('none');
            let relatedProductsWrap = document.querySelector('.additional-products-cart--items--wrap');
            let slidesToShow = 3;
            if (document.querySelector('.cart__contents')) {
                slidesToShow = 3;
            }
            if (relatedProductsWrap && !relatedProductsWrap.className.includes('slick-slider')) {
                $(relatedProductsWrap).slick({
                    infinite: true,
                    slidesToShow: slidesToShow,
                    slidesToScroll: 1,
                    dots: false,
                    centerMode: false,
                    prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<path d="M0.646444 3.64742C0.451181 3.84269 0.451181 4.15927 0.646444 4.35453L3.82842 7.53651C4.02369 7.73177 4.34027 7.73177 4.53553 7.53651C4.73079 7.34125 4.73079 7.02467 4.53553 6.8294L1.7071 4.00098L4.53553 1.17255C4.73079 0.977287 4.73079 0.660704 4.53553 0.465442C4.34027 0.27018 4.02369 0.27018 3.82842 0.465442L0.646444 3.64742ZM21 3.50098L0.999998 3.50098V4.50098L21 4.50098V3.50098Z" fill="black"/>\n' +
                        '</svg>\n</button>',
                    nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                        '<path d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4.5H20V3.5H0V4.5Z" fill="black"/>\n' +
                        '</svg>\n </button>',
                    responsive: [
                        {
                            breakpoint: 559,
                            settings: {
                                slidesToShow: 1.25,
                                centerPadding: '10px'
                            }
                        },
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 3,
                                centerPadding: '10px'
                            }
                        }
                    ]
                });
            }
        } else {
            products.classList.add('hidden');

            additionalProductsCart.classList.add('visibility-hidden--custom');
            additionalProductsCart.classList.add('none');
        }
    }
    function checkboxDate_change() {
        allBlocks.forEach((i) => {
            i.classList.add('hidden')
            if (products) {
                products.classList.add('visibility-hidden--custom')
                products.classList.add('none')
            }
        })
        if (checkboxDate.checked) {
            checkboxBlock.classList.remove('hidden');
            const preselectedDate = checkboxDate.getAttribute('preselectedDate');
            if (preselectedDate) {
                fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            "Delivery Date": null
                        }
                    })
                }).then(response => response.json())
                    .then(data => {
                        // location.reload();
                    })
                checkboxBlock.classList.add('hidden');
            }
        } else {
            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        "Delivery Date": null
                    }
                })
            }).then(response => response.json())
                .then(data => {
                    checkboxZakladynka.checked = false;
                    checkboxZakladynka.addEventListener('change', checkboxZakladynka_change);
                    //location.reload();
                })
            checkboxBlock.classList.add('hidden');
            date_wrap_val.innerHTML = " ";
            checkboxDate.classList.remove('change-date');
            datePicker.value = '';
            checkboxDate.setAttribute('preselectedDate', '');
            checkboxDate.removeAttribute('checked');
        }
        checkboxZakladynka.checked = false;
        checkboxZakladynka.addEventListener('change', checkboxZakladynka_change);
    }
    if (checkboxDate) {
        checkboxDate.addEventListener('change', checkboxDate_change);
    }
    if (checkboxZakladynka) {
        checkboxZakladynka.addEventListener('change', checkboxZakladynka_change);
    }
    if (updateDateButton) {
        updateDateButton.addEventListener('click', () => {
            const selectedDate = datePicker.value;

            fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    attributes: {
                        "Delivery Date": selectedDate
                    }
                })
            })
                .then(response => response.json())
                .then(data => {
                    // location.reload();
                    if (checkboxDate) {
                        checkboxDate.classList.add('change-date')
                    }
                    if (date_wrap) {
                        date_wrap.classList.add('hidden');
                    }
                    if (date_wrap_val && selectedDate) {
                        date_wrap_val.innerHTML = ": " + selectedDate.toString();
                        checkboxDate.setAttribute('preselectedDate', selectedDate.toString());
                    } else {
                        date_wrap_val.innerHTML = " ";
                        checkboxDate.classList.remove('change-date')
                        checkboxDate.checked = false;
                        checkboxDate.removeAttribute('checked');
                    }

                })
                .catch(error => {
                    console.error('Error updating delivery date:', error);
                });
        });
    }
    const zakladynkaSvg = document.querySelectorAll('.zakladynka-svg svg');
    if (zakladynkaSvg) {
        zakladynkaSvg.forEach(function (svg) {
            svg.addEventListener('click', () => {
                var zakladynkaSlider = document.querySelector('.additional-products-cart');
                // console.log('zakladynkaSlider');
                zakladynkaSlider.classList.toggle('hidden');
                let productsWrap = document.getElementById('cart-products');
                if (!zakladynkaSlider.classList.contains('hidden')) {
                    products.classList.remove('hidden');
                    let relatedProductsWrap = document.querySelector('.additional-products-cart--items--wrap');
                    if (productsWrap && !productsWrap.classList.contains('additional-product-opened')) {
                        productsWrap.classList.add('additional-product-opened')
                    }
                    if (relatedProductsWrap && !relatedProductsWrap.className.includes('slick-slider')) {
                        $(relatedProductsWrap).slick({
                            infinite: true,
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            dots: false,
                            centerMode: false,
                            prevArrow: '<button type="button" class="slick-prev slick-arrow"><svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                '<path d="M0.646444 3.64742C0.451181 3.84269 0.451181 4.15927 0.646444 4.35453L3.82842 7.53651C4.02369 7.73177 4.34027 7.73177 4.53553 7.53651C4.73079 7.34125 4.73079 7.02467 4.53553 6.8294L1.7071 4.00098L4.53553 1.17255C4.73079 0.977287 4.73079 0.660704 4.53553 0.465442C4.34027 0.27018 4.02369 0.27018 3.82842 0.465442L0.646444 3.64742ZM21 3.50098L0.999998 3.50098V4.50098L21 4.50098V3.50098Z" fill="black"/>\n' +
                                '</svg>\n</button>',
                            nextArrow: '<button type="button" class="slick-next slick-arrow"><svg width="21" height="8" viewBox="0 0 21 8" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
                                '<path d="M20.3536 4.35355C20.5488 4.15829 20.5488 3.84171 20.3536 3.64645L17.1716 0.464466C16.9763 0.269204 16.6597 0.269204 16.4645 0.464466C16.2692 0.659728 16.2692 0.976311 16.4645 1.17157L19.2929 4L16.4645 6.82843C16.2692 7.02369 16.2692 7.34027 16.4645 7.53553C16.6597 7.7308 16.9763 7.7308 17.1716 7.53553L20.3536 4.35355ZM0 4.5H20V3.5H0V4.5Z" fill="black"/>\n' +
                                '</svg>\n </button>',
                            responsive: [
                                {
                                    breakpoint: 769,
                                    settings: {
                                        slidesToShow: 2,
                                        centerPadding: '10px'
                                    }
                                }
                            ]
                        });
                    }
                } else {
                    if (productsWrap) {
                        productsWrap.classList.remove('additional-product-opened')
                    }
                    products.classList.add('hidden');
                }
            });
        });
    }
});